import React from 'react'
import { Checkbox, Descriptions, Form, Input, InputNumber, Switch } from 'antd'
import { CheckCircleTwoTone } from '@ant-design/icons'
import { AsYouType } from 'libphonenumber-js'
import { mainTwoToneColor } from '../../../variables'
import moment from 'moment'
import MomentDatePicker from '../../../utils/timezone/MomentDatePicker'
import MomentTimePicker from '../../../utils/timezone/MomentTimePicker'

export const customTypes = ['Text', 'Address', 'Phone', 'Number', 'Date', 'Time', 'Checkbox', 'Switch', 'Textarea']

export const renderFieldsData = (fieldsData, selected) =>
  fieldsData?.companyCustomFields?.map(field => {
    if (field) {
      const value = selected?.customFields?.find(customField => customField.field && customField.field.id === field.id)?.value
      return value ? (
        <Descriptions.Item label={field.name} key={field.id}>
          {renderCorrectValue(value, field.type)}
        </Descriptions.Item>
      ) : null
    } else {
      return null
    }
  })

function renderCorrectValue(value, type) {
  switch (type) {
    case 'Date':
      return value && value !== 'null' ? moment(new Date(value)).format('LL') : ''
    case 'Time':
      return value && value !== 'null' ? moment(new Date(value)).format('hh:mm A') : ''
    case 'Checkbox':
    case 'Switch':
      return value ? <CheckCircleTwoTone twoToneColor={mainTwoToneColor} /> : ''
    default:
      return value
  }
}

export function renderCorrectFieldValue(value, type, code) {
  if (!value || value === 'null') {
    if (code && type === 'Phone') {
      return code
    }
    return null
  }
  switch (type) {
    case 'Time':
    case 'Date':
      return moment(new Date(value))
    case 'Checkbox':
    case 'Switch':
      return value === 'true'
    default:
      return value
  }
}

export const getInitialCustomFields = (fieldsData, selectedItem, code) =>
  fieldsData?.companyCustomFields.reduce((obj, item) => {
    const customField = selectedItem.customFields?.find(customField => customField.field.id === item.id) || {}
    obj[item.id] = {
      id: customField.id || item.id,
      value: renderCorrectFieldValue(customField.value, item.type, code)
    }
    return obj
  }, {})

export const getCustomFieldsForSubmit = customFields =>
  customFields
    ? Object.keys(customFields)
        .map(id => ({
          id: customFields[id].id,
          value: customFields[id].value || customFields[id].value === false ? String(customFields[id].value) : ''
        }))
        .filter(field => field.id)
    : []

export function customFields(type, name, required, id, t) {
  switch (type) {
    case 'Text':
      return (
        <>
          <Form.Item noStyle name={['customFields', id, 'id']} shouldUpdate>
            <span />
          </Form.Item>
          <Form.Item
            label={name}
            hasFeedback={required}
            name={['customFields', id, 'value']}
            rules={[
              { max: 200, message: t('common.fieldLong', { name }) },
              { required, message: t('common.fieldRequired', { name }) }
            ]}
          >
            <Input autoComplete="off" />
          </Form.Item>
        </>
      )
    case 'Phone':
      return (
        <>
          <Form.Item noStyle name={['customFields', id, 'id']} shouldUpdate>
            <span />
          </Form.Item>
          <Form.Item
            label={name}
            normalize={value => new AsYouType().input(value)}
            hasFeedback={required}
            name={['customFields', id, 'value']}
            rules={[
              { max: 200, message: t('common.fieldLong', { name }) },
              { required, message: t('common.fieldRequired', { name }) }
            ]}
          >
            <Input autoComplete="off" type="tel" />
          </Form.Item>
        </>
      )
    case 'Address':
      return (
        <>
          <Form.Item noStyle name={['customFields', id, 'id']} shouldUpdate>
            <span />
          </Form.Item>
          <Form.Item
            label={name}
            hasFeedback={required}
            name={['customFields', id, 'value']}
            rules={[
              { max: 200, message: t('common.fieldLong', { name }) },
              { required, message: t('common.fieldRequired', { name }) }
            ]}
          >
            <Input maxLength={200} />
          </Form.Item>
        </>
      )
    case 'Textarea':
      return (
        <>
          <Form.Item noStyle name={['customFields', id, 'id']} shouldUpdate>
            <span />
          </Form.Item>
          <Form.Item
            label={name}
            hasFeedback={required}
            name={['customFields', id, 'value']}
            rules={[
              { max: 200, message: t('common.fieldLong', { name }) },
              { required, message: t('common.fieldRequired', { name }) }
            ]}
          >
            <Input.TextArea />
          </Form.Item>
        </>
      )
    case 'Number':
      return (
        <>
          <Form.Item noStyle name={['customFields', id, 'id']} shouldUpdate>
            <span />
          </Form.Item>
          <Form.Item
            label={name}
            hasFeedback={required}
            name={['customFields', id, 'value']}
            rules={[{ required, message: t('common.fieldRequired', { name }) }]}
          >
            <InputNumber inputMode="decimal" />
          </Form.Item>
        </>
      )
    case 'Date':
      return (
        <>
          <Form.Item noStyle name={['customFields', id, 'id']} shouldUpdate>
            <span />
          </Form.Item>
          <Form.Item
            label={name}
            hasFeedback={required}
            name={['customFields', id, 'value']}
            rules={[{ required, message: t('common.fieldRequired', { name }) }]}
          >
            <MomentDatePicker format={['D/M/YYYY', 'DD/MM/YYYY']} placeholder="DD/MM/YYYY" />
          </Form.Item>
        </>
      )
    case 'Time':
      return (
        <>
          <Form.Item noStyle name={['customFields', id, 'id']} shouldUpdate>
            <span />
          </Form.Item>
          <Form.Item
            label={name}
            hasFeedback={required}
            name={['customFields', id, 'value']}
            rules={[{ required, message: t('common.fieldRequired', { name }) }]}
          >
            <MomentTimePicker />
          </Form.Item>
        </>
      )
    case 'Checkbox':
      return (
        <>
          <Form.Item noStyle name={['customFields', id, 'id']} shouldUpdate>
            <span />
          </Form.Item>
          <Form.Item
            label={name}
            name={['customFields', id, 'value']}
            rules={[{ required, message: t('common.fieldRequired', { name }) }]}
            valuePropName="checked"
          >
            <Checkbox />
          </Form.Item>
        </>
      )
    case 'Switch':
    default:
      return (
        <>
          <Form.Item noStyle name={['customFields', id, 'id']} shouldUpdate>
            <span />
          </Form.Item>
          <Form.Item
            label={name}
            name={['customFields', id, 'value']}
            rules={[{ required, message: t('common.fieldRequired', { name }) }]}
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
        </>
      )
  }
}

// TODO FIX CHeCK BOX
export function customFieldsPlaceHolder(type, t) {
  switch (type) {
    case 'Text':
      return <Input readOnly aria-readonly placeholder={t('common.addText')} />
    case 'Phone':
      return <Input readOnly aria-readonly placeholder="+1 123 123 123" />
    case 'Address':
      return <Input readOnly aria-readonly placeholder={t('common.addAddress')} />
    case 'Textarea':
      return <Input.TextArea readOnly aria-readonly placeholder={t('calendar.addDetails')} />
    case 'Number':
      return <InputNumber inputMode="decimal" readOnly aria-readonly placeholder={10.1} />
    case 'Date':
      return (
        <MomentDatePicker
          readOnly
          aria-readonly
          open={false}
          placeholder={moment().format('DD/MM/YYYY')}
          format={['D/M/YYYY', 'DD/MM/YYYY']}
        />
      )
    case 'Time':
      return <MomentTimePicker readOnly aria-readonly open={false} placeholder={moment().format('LTS')} />
    case 'Checkbox':
      return <Checkbox checked />
    case 'Switch':
    default:
      return <Switch checked />
  }
}
